import { IJwtPayload } from "./commonClasses";

declare var angular: any;

interface ILang {
    code: string;
    descriptionKey: string;
}

module GlobalApplicationData {
    const SUPPORTED_LANGS: Array<string> = ["it", "en", "de"];

    angular.module("AdeMesApp").factory("GlobalApplicationData", [() => {
        let GlobalApplicationData = {
            
            //Base service url
            baseServicesUrl: "https://test.adesuite.com/acme",
            
            //Contesto applicativo
            applicationContext:"https://test.adesuite.com/acme/rest/service/ademes/",
            
            // Indica la pagina originariamente richiesta dall'utente che ha scatenato l'autenticazione
            orginalRequestedURL: <string>null,

            // Variabile che contiene il token di autenticazione
            identityToken: <string>null,

            // Informazioni aggiuntive legate al token di autenticazione
            jwtPayload: <IJwtPayload>null,

            // Definisco l'array che conterrà tutte le possibili azioni a cui un utente è abilitato
            auths: <Array<string>>[],

            // Definisco l'array per le lingue disponibili nell'applicazione che sarà popolato da authenticatingCtrl
            // L'attributo mandatory indica che è obbilgatoria e di default (infatti deve sempre essercene solo una di mandatory)
            langs: <Array<ILang>>[],

            //Token di default
            token: "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VySWQiOiIxMDAwOTY1IiwidXNlcm5hbWUiOiJ1c2VyMSIsImF1dGhvcml6YXRpb25zIjpbXX0.7mW2RQNK2iSwrO-vZyGaI9q0gMLVyh-_PDXMyklS-dWeF--D14Qn6jKcl3pOY9rCO0Ivm9UHdYg73onHcVQFaA",

            //Client di default
            ad_client_id: "1000095", 

            //Url di default
            default_state: "calendar",
            
            //Visualizzare ore lavorate e ultimo rapportino: true, per non visualizzarle mettere a false
            headerDetail: false, 

            //Visualizzare bottone per accedere ai documenti
            documentButton: false
        };

        SUPPORTED_LANGS.forEach(lang => {
            GlobalApplicationData.langs.push({
                code: lang,
                descriptionKey: "generic.langs." + lang
            });
        });

        return GlobalApplicationData;
    }])
};